/*
 * Translation reference forked from @backstage/plugin-org
 * Original file: plugins/org/src/translation.ts
 */
import { TranslationRef, createTranslationRef } from '@backstage/frontend-plugin-api'

/**
 * Translation reference for the org plugin components
 */
export const orgTranslationRef: TranslationRef<any> = createTranslationRef({
  id: 'sennder-members-list',
  messages: {
    membersListCard: {
      title: 'Members',
      subtitle: 'of {{groupName}}',
      paginationLabel: ', page {{page}} of {{nbPages}}',
      noMembersDescription: 'This group has no members.',
      aggregateMembersToggle: {
        directMembers: 'Direct Members',
        aggregatedMembers: 'Aggregated Members',
        ariaLabel: 'Users Type Switch'
      }
    }
  }
})
